module.exports = __webpack_public_path__ + "img/dcivi-logo2.18d5b339.png";